import PaymentSingleReceived from './PaymentSingleReceived'
import PaymentSingle from './PaymentSingle'
import PaymentList from './PaymentList'

export default {
  PaymentSingle,
  PaymentList,
  PaymentSingleReceived
}
